module.exports = __webpack_public_path__ + "img/back exposed 7mm zipper length.a6c52777.png";